<template>
  <div>
    <Modal class="editBlock importcontact" v-model="modal" title="导入客戶" width="35" footer-hide>
      <div class="bodyfirst">
        <div class="title">选择导入的数据文件</div>
        <div class="content">
          <Row>
            <Col span="3" class="necessary">
              <label>
                <span>*</span>数据文件
              </label>
            </Col>
            <Col span="7">
              <div class="editInpu">
                <Input>
                  <div class slot="suffix">
                    <img src="~assets/img/public/filelinear.png"/>
                  </div>
                </Input>
              </div>
            </Col>
            <Col span="7">
              <p> (联系人数据Excel文件)</p>
            </Col>
          </Row>
        </div>
      </div>
      <div class="bodytwice">
        <div class="title">联系人信息导入说明</div>
          <div class="content">
            <Row>
              <span>1</span>上传联系人数据的Excel文件
            </Row>
            <Row>
              <span>2</span>系统自动匹配，客户数据直接导入
            </Row>
            <Row>
              <span>3</span>开始导入联系人数据
            </Row>
          </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div class="btn" >确定</div>
          <div class="btn" >重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "ModalImport",
  props: ["importModal"],
  data () {
    return {

    }
  },
  computed: {
    modal: {
      get () {
        return this.importModal
      },
      set (val) {
        this.$emit("update:importModal",val)
      }
    }
  },
  methods: {

  }
}
</script>
<style lang="less">
.editBlock.importcontact {
  .ivu-modal-body {
    .ivu-col {
      &.necessary {
        font-size: 15px;
        margin-left: -8px;
        transform: translateY(5px);
        span {
          color: var(--main-red);
        }
      }
      p{
        font-size: 12px;
        color: var(--content-black);
        transform: translateY(7px);
        margin-left: 15px;
      }
    }
    .editInput {
      width: 70%;
      margin-top: 6px;
      margin-left: 10px;
      margin-bottom: 9px;
    }
    .ivu-input-suffix {
      background-color: #f8f8f8;
      border: solid 1px var(--border-black);
      padding-top: 8px;
    }
    .bodytwice {
      .content {
        padding: 15px 25px 20px 100px;
        font-size: 15px;
      }
      span{
        display: inline-block;
        background-color: #75e2ff;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        text-align: center;
        color: #fff;
        margin-top: 15px;
        margin-right: 10px;
      }
    }
  }
}
</style>